import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { MatTabGroup } from "@angular/material/tabs";
import { SidebarService } from '../shared/components/sidebar/sidebar.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {

  showSidebar: boolean = false;

  constructor(public authService: AuthService,
    private sidebarService: SidebarService) {


  }

  ngOnInit() {
    this.sidebarService.showSideBarObservable.subscribe(result => {
      this.showSidebar = result;
    });
  }

}

